import React from "react";
import TextField from "../Reusable/TextInput";
import { tw } from "@careinfo/tailwind";
import LocalCombobox from "../Reusable/ComboBox";
import MultipleSelectField from "../Reusable/MultipleCountryField";
import APIS from "../../constant/EndPoint";
import NACell from "../Reusable/DataTable/NACell";
import DataTable from "../Reusable/DataTable";
const TypeData = [
  {
    name: "flat",
    id: "flat",
  },
  {
    name: "percentage",
    id: "percentage",
  },
];
const DeliveryChargeTemplateForm = ({
  errors,
  register,
  setValue,
  getValues,
  control,
  clearErrors,
  watch,
}: any) => {
  return (
    <>
      <div className={tw`grid grid-cols-2 md:grid-cols-2 gap-x-4 mx-4`}>
        <TextField
          label={"Name"}
          register={register("name")}
          errors={errors?.name}
        />
        <TextField
          label={"Base Weight"}
          register={register("base_weight")}
          errors={errors?.base_weight}
        />
        <TextField
          label={"Base Piece"}
          register={register("base_piece")}
          errors={errors?.base_piece}
        />
        <TextField
          label={"Base Volume"}
          register={register("base_volume")}
          errors={errors?.base_volume}
        />
        <LocalCombobox
          label={"Charge Type"}
          placeholder={"Search charge type"}
          props={{}}
          control={control}
          errors={errors?.charge_type}
          name={"charge_type"}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
          data={TypeData}
        />
        <TextField
          label={"Charge Rate"}
          register={register("charge")}
          errors={errors?.charge}
        />
      </div>
     
    </>
  );
};

export default DeliveryChargeTemplateForm;
